'use strict';

var _theme = require('./theme.config');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Bind theme settings and styles to client
window._frontendConnect_ = _theme2.default;